export default {
  viewBox: "0 0 24 24",
  html: "<path stroke=\"none\" d=\"M19.893 3.001H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h15.893c1.103 0 2-.897 2-2V5a2.003 2.003 0 0 0-2-1.999M8 19.001H4V8h4zm6 0h-4V8h4zm2 0V8h3.893l.001 11.001z\"/>"
};